import { call } from 'redux-saga/effects';
import * as Api from '../../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../../helpers/saga';
import {
  fetchInventoryTagOptions as fetchInventoryTagOptionsRoutine,
  fetchInventoryPackageItems as fetchInventoryPackageItemsRoutine,
  fetchInventoryItemOptions as fetchInventoryItemOptionsRoutine,
  fetchInventoryPackageActiveReservationOrderItemsCount as fetchInventoryPackageActiveReservationOrderItemsCountRoutine
} from './routines';

export const fetchInventoryTagOptions = () =>
  sagaRoutineRequest(fetchInventoryTagOptionsRoutine, {
    request: () => call(Api.fetchInventoryTagOptions)
  });

export const fetchInventoryItemOptions = () =>
  sagaRoutineRequest(fetchInventoryItemOptionsRoutine, {
    request: () => call(Api.fetchInventoryItemOptions)
  });

export const fetchInventoryPackageItems = ({ payload: id }) =>
  sagaRoutineRequest(fetchInventoryPackageItemsRoutine, {
    request: () => call(Api.fetchInventoryPackageItems, id)
  });

export const fetchInventoryPackageActiveReservationOrderItemsCount = ({
  payload: id
}) =>
  sagaRoutineRequest(
    fetchInventoryPackageActiveReservationOrderItemsCountRoutine,
    {
      request: () =>
        call(Api.fetchInventoryPackageActiveReservationOrderItemsCount, id)
    }
  );
